(() => {
  const qs = (root, selector) => Array.from(root.querySelectorAll(selector));
  let cartEscapeBound = false;

  function initHero(root) {
    const slides = qs(root, "[data-tps-slide]");
    const dots = qs(root, "[data-tps-dot]");
    if (!slides.length) return;
    let index = slides.findIndex((slide) => slide.classList.contains("is-active"));
    if (index < 0) index = 0;
    let timer;
    const interval = Number(root.dataset.autoplay || 0);

    const scheduleNext = () => {
      if (timer) window.clearTimeout(timer);
      if (interval > 0 && slides.length > 1) {
        timer = window.setTimeout(() => setActive(index + 1), interval * 1000);
      }
    };

    const setActive = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle("is-active", i === index));
      dots.forEach((dot) => {
        const dotIndex = Number(dot.dataset.tpsDot || 0);
        dot.classList.toggle("is-active", dotIndex === index);
        const fill = dot.querySelector("span");
        if (fill && dotIndex === index) {
          fill.style.animation = "none";
          fill.offsetHeight;
          fill.style.animation = "";
        }
      });
      scheduleNext();
    };

    root.querySelector("[data-tps-prev]")?.addEventListener("click", () => setActive(index - 1));
    root.querySelector("[data-tps-next]")?.addEventListener("click", () => setActive(index + 1));
    dots.forEach((dot) => dot.addEventListener("click", () => setActive(Number(dot.dataset.tpsDot || 0))));

    scheduleNext();
  }

  function initSolutionsSlider(root) {
    if (root.dataset.tpsSolutionsBound === "true") return;
    const items = qs(root, "[data-tps-solutions-item]");
    const dots = qs(root, "[data-tps-solutions-dot]");
    if (!items.length) return;
    root.dataset.tpsSolutionsBound = "true";
    let index = items.findIndex((item) => item.classList.contains("is-active"));
    if (index < 0) index = 0;
    let timer;
    const interval = Number(root.dataset.autoplay || 0);

    const scheduleNext = () => {
      if (timer) window.clearTimeout(timer);
      if (interval > 0 && items.length > 1) {
        timer = window.setTimeout(() => setActive(index + 1), interval * 1000);
      }
    };

    const setActive = (next) => {
      index = (next + items.length) % items.length;
      items.forEach((item, itemIndex) => item.classList.toggle("is-active", itemIndex === index));
      dots.forEach((dot) => {
        const dotIndex = Number(dot.dataset.tpsSolutionsDot || 0);
        dot.classList.toggle("is-active", dotIndex === index);
        const fill = dot.querySelector("span");
        if (fill && dotIndex === index) {
          fill.style.animation = "none";
          fill.offsetHeight;
          fill.style.animation = "";
        }
      });
      scheduleNext();
    };

    dots.forEach((dot) => dot.addEventListener("click", () => setActive(Number(dot.dataset.tpsSolutionsDot || 0))));
    setActive(index);
  }

  function initCarousel(root) {
    const track = root.querySelector("[data-tps-track]");
    const viewport = root.querySelector("[data-tps-viewport]");
    const items = qs(root, "[data-tps-item]");
    const prev = root.querySelector("[data-tps-prev]");
    const next = root.querySelector("[data-tps-next]");
    if (!track || !viewport || !items.length) return;
    let index = 0;
    const isLoop = !!root.closest(".tps-instagram-section");

    const maxIndex = () => {
      const first = items[0];
      const gap = Number(getComputedStyle(track).columnGap.replace("px", "")) || 0;
      const step = first.getBoundingClientRect().width + gap;
      const visible = Math.max(1, Math.floor((viewport.getBoundingClientRect().width + gap) / step));
      return Math.max(0, items.length - visible);
    };

    const update = () => {
      const first = items[0];
      const gap = Number(getComputedStyle(track).columnGap.replace("px", "")) || 0;
      const step = first.getBoundingClientRect().width + gap;
      index = Math.min(index, maxIndex());
      track.style.transform = `translateX(-${index * step}px)`;
      prev?.toggleAttribute("disabled", !isLoop && index <= 0);
      next?.toggleAttribute("disabled", !isLoop && index >= maxIndex());
    };

    prev?.addEventListener("click", () => {
      if (isLoop && index <= 0) index = maxIndex();
      else index = Math.max(0, index - 1);
      update();
    });
    next?.addEventListener("click", () => {
      if (isLoop && index >= maxIndex()) index = 0;
      else index = Math.min(maxIndex(), index + 1);
      update();
    });
    window.addEventListener("resize", update, { passive: true });
    update();
  }

  function initAccordion(root) {
    const items = qs(root, "[data-tps-accordion-item]");
    const images = qs(root, "[data-tps-accordion-image]");
    items.forEach((item, i) => {
      item.querySelector("[data-tps-accordion-button]")?.addEventListener("click", () => {
        const alreadyOpen = item.classList.contains("is-open");
        items.forEach((node) => node.classList.remove("is-open"));
        images.forEach((image) => image.classList.remove("is-active"));
        if (!alreadyOpen) {
          item.classList.add("is-open");
          images[i]?.classList.add("is-active");
        }
      });
    });
  }

  function initHeader(root) {
    const toggle = root.querySelector("[data-tps-menu-toggle]");
    if (toggle && toggle.dataset.tpsBound !== "true") {
      toggle.dataset.tpsBound = "true";
      toggle.addEventListener("click", () => {
        const open = root.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded", String(open));
      });
    }

    const closeDrawer = () => {
      root.classList.remove("is-open");
      toggle?.setAttribute("aria-expanded", "false");
    };
    const menuClose = root.querySelector("[data-tps-menu-close]");
    if (menuClose && menuClose.dataset.tpsBound !== "true") {
      menuClose.dataset.tpsBound = "true";
      menuClose.addEventListener("click", closeDrawer);
    }
    if (root.dataset.tpsMenuEscBound !== "true") {
      root.dataset.tpsMenuEscBound = "true";
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && root.classList.contains("is-open")) closeDrawer();
      });
    }

    qs(root, "[data-tps-drawer-toggle]").forEach((btn) => {
      if (btn.dataset.tpsBound === "true") return;
      btn.dataset.tpsBound = "true";
      btn.addEventListener("click", () => {
        const group = btn.closest(".tps-header__drawer-group");
        if (!group) return;
        const open = group.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", String(open));
      });
    });

    const searchToggle = root.querySelector("[data-tps-search-toggle]");
    const searchOverlay = root.querySelector("[data-tps-search-overlay]");
    if (searchToggle && searchOverlay && searchToggle.dataset.tpsBound !== "true") {
      searchToggle.dataset.tpsBound = "true";
      const closeBtn = searchOverlay.querySelector("[data-tps-search-close]");
      const overlayInput = searchOverlay.querySelector("[data-tps-search-input]");

      const openSearch = () => {
        searchOverlay.classList.add("is-open");
        searchOverlay.setAttribute("aria-hidden", "false");
        document.body.classList.add("tps-search-overlay-open");
        window.setTimeout(() => overlayInput?.focus(), 50);
      };

      const closeSearch = () => {
        searchOverlay.classList.remove("is-open");
        searchOverlay.setAttribute("aria-hidden", "true");
        document.body.classList.remove("tps-search-overlay-open");
      };

      searchToggle.addEventListener("click", openSearch);
      closeBtn?.addEventListener("click", closeSearch);
      searchOverlay.addEventListener("click", (event) => {
        if (event.target === searchOverlay) closeSearch();
      });
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && searchOverlay.classList.contains("is-open")) closeSearch();
      });
    }
  }

  function escapeHtml(value) {
    return String(value ?? "").replace(/[&<>"']/g, (char) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    }[char]));
  }

  function renderSearchResults(container, products, term) {
    if (!products.length) {
      container.innerHTML = `<p class="tps-search-results__empty">"${escapeHtml(term)}" için sonuç bulunamadı.</p>`;
      return;
    }
    const items = products
      .slice(0, 6)
      .map((product) => {
        const image = product.featured_image?.url || product.image || "";
        const price = product.price || "";
        return `
          <a class="tps-search-results__item" href="${product.url}">
            <span class="tps-search-results__thumb">${image ? `<img src="${image}&width=80" alt="" loading="lazy" width="56" height="56">` : ""}</span>
            <span class="tps-search-results__info">
              <span class="tps-search-results__title">${escapeHtml(product.title)}</span>
              <span class="tps-search-results__price">${escapeHtml(price)}</span>
            </span>
          </a>`;
      })
      .join("");
    container.innerHTML = `
      <div class="tps-search-results__list">${items}</div>
      <a class="tps-search-results__view-all" href="/search?q=${encodeURIComponent(term)}">"${escapeHtml(term)}" için tüm sonuçları gör</a>
    `;
  }

  function initPredictiveSearch(form) {
    if (form.dataset.tpsSearchBound === "true") return;
    form.dataset.tpsSearchBound = "true";

    const input = form.querySelector("[data-tps-search-input]");
    const container = form.closest("[data-tps-search-overlay]") || form;
    const results = container.querySelector("[data-tps-search-results]");
    if (!input || !results) return;

    let debounceTimer;
    let activeController;

    const hideResults = () => {
      results.hidden = true;
      results.innerHTML = "";
    };

    const runSearch = async (term) => {
      if (activeController) activeController.abort();
      activeController = new AbortController();
      results.hidden = false;
      results.innerHTML = `<p class="tps-search-results__loading">Aranıyor...</p>`;
      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`,
          { signal: activeController.signal, headers: { Accept: "application/json" } }
        );
        if (!response.ok) throw new Error("Predictive search failed");
        const data = await response.json();
        const products = data?.resources?.results?.products || [];
        renderSearchResults(results, products, term);
      } catch (error) {
        if (error.name !== "AbortError") {
          results.innerHTML = `<p class="tps-search-results__empty">Arama yapılamadı, lütfen tekrar deneyin.</p>`;
        }
      }
    };

    input.addEventListener("input", () => {
      const term = input.value.trim();
      window.clearTimeout(debounceTimer);
      if (term.length < 2) {
        hideResults();
        return;
      }
      debounceTimer = window.setTimeout(() => runSearch(term), 280);
    });

    input.addEventListener("focus", () => {
      if (input.value.trim().length >= 2 && results.innerHTML) results.hidden = false;
    });

    document.addEventListener("click", (event) => {
      if (!form.contains(event.target) && !results.contains(event.target)) {
        results.hidden = true;
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") hideResults();
    });
  }

  function initCollectionGrid(root) {
    if (root.dataset.tpsGridBound === "true") return;
    const grid = root.querySelector(".tps-collection-products .tps-product-grid");
    const buttons = qs(root, "[data-tps-grid-columns]");
    if (!grid || !buttons.length) return;
    root.dataset.tpsGridBound = "true";
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const columns = Number(button.dataset.tpsGridColumns || 4);
        root.style.setProperty("--tps-desktop-columns", String(columns));
        buttons.forEach((node) => node.classList.toggle("is-active", node === button));
      });
    });
  }

  async function refreshCartCount() {
    const badges = qs(document, "[data-tps-cart-count]");
    if (!badges.length) return;
    try {
      const response = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      if (!response.ok) return;
      const cart = await response.json();
      badges.forEach((badge) => {
        badge.textContent = String(cart.item_count || 0);
        badge.hidden = !cart.item_count;
      });
    } catch (error) {
      // Cart count is a progressive enhancement; normal cart behavior still works.
    }
  }

  const getCartDrawer = () => document.querySelector("[data-tps-cart-drawer]");

  function setCartDrawer(open) {
    const drawer = getCartDrawer();
    if (!drawer) return;
    drawer.classList.toggle("is-open", open);
    drawer.setAttribute("aria-hidden", String(!open));
    document.body.classList.toggle("tps-mini-cart-open", open);
  }

  async function refreshCartDrawer(openAfter = false) {
    const currentDrawer = getCartDrawer();
    if (!currentDrawer) {
      if (openAfter) window.location.href = "/cart";
      return;
    }
    try {
      const response = await fetch("/cart?section_id=tps-cart-drawer", { headers: { Accept: "text/html" } });
      if (!response.ok) throw new Error("Cart drawer refresh failed");
      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, "text/html");
      const nextDrawer = nextDocument.querySelector("[data-tps-cart-drawer]");
      if (nextDrawer) {
        currentDrawer.replaceWith(nextDrawer);
        initCartDrawer(nextDrawer);
        initProductCardForms(nextDrawer);
      }
      if (openAfter) setCartDrawer(true);
    } catch (error) {
      if (openAfter) setCartDrawer(true);
    }
  }

  function initProductCardForms(scope) {
    qs(scope, ".tps-product-card__form, .tps-cart-form, form[action='/cart/add']").forEach((form) => {
      if (form.dataset.tpsCartBound === "true") return;
      form.dataset.tpsCartBound = "true";
      form.addEventListener("submit", async (event) => {
        if (event.submitter?.matches("[data-tps-buy-now]")) {
          let returnInput = form.querySelector("input[name='return_to']");
          if (!returnInput) {
            returnInput = document.createElement("input");
            returnInput.type = "hidden";
            returnInput.name = "return_to";
            form.appendChild(returnInput);
          }
          returnInput.value = "/checkout";
          return;
        }
        event.preventDefault();
        const button = form.querySelector("button[type='submit']");
        if (button?.disabled) return;
        const originalText = button ? button.textContent : "";
        try {
          if (button) {
            button.disabled = true;
            button.textContent = "EKLENİYOR";
          }
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { Accept: "application/json" },
            body: new FormData(form),
          });
          if (!response.ok) throw new Error("Cart add failed");
          if (button) button.textContent = "EKLENDİ";
          await refreshCartCount();
          await refreshCartDrawer(true);
          window.setTimeout(() => {
            if (button) {
              button.disabled = false;
              button.textContent = originalText;
            }
          }, 1000);
        } catch (error) {
          form.submit();
        }
      });
    });
  }

  function initCartDrawer(scope) {
    qs(scope, "[data-tps-cart-open]").forEach((trigger) => {
      if (trigger.dataset.tpsCartOpenBound === "true") return;
      trigger.dataset.tpsCartOpenBound = "true";
      trigger.addEventListener("click", (event) => {
        if (getCartDrawer()) {
          event.preventDefault();
          refreshCartDrawer(true);
        }
      });
    });

    const drawers = scope.matches?.("[data-tps-cart-drawer]") ? [scope] : qs(scope, "[data-tps-cart-drawer]");
    drawers.forEach((drawer) => {
      qs(drawer, "[data-tps-cart-close]").forEach((button) => {
        if (button.dataset.tpsCartCloseBound === "true") return;
        button.dataset.tpsCartCloseBound = "true";
        button.addEventListener("click", () => setCartDrawer(false));
      });

      qs(drawer, "[data-tps-cart-change]").forEach((button) => {
        if (button.dataset.tpsCartChangeBound === "true") return;
        button.dataset.tpsCartChangeBound = "true";
        button.addEventListener("click", async () => {
          if (button.disabled) return;
          button.disabled = true;
          try {
            const line = Number(button.dataset.line || 0);
            const quantity = Math.max(0, Number(button.dataset.quantity || 0));
            const response = await fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json", Accept: "application/json" },
              body: JSON.stringify({ line, quantity }),
            });
            if (!response.ok) throw new Error("Cart change failed");
            await refreshCartCount();
            await refreshCartDrawer(true);
          } catch (error) {
            window.location.href = "/cart";
          }
        });
      });
    });

    if (!cartEscapeBound) {
      cartEscapeBound = true;
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") setCartDrawer(false);
      });
      document.addEventListener("cart:refresh", () => refreshCartDrawer(false));
    }
  }

  function initProductGallery(root) {
    if (root.dataset.tpsGalleryBound === "true") return;
    const mediaList = root.querySelector("[data-tps-product-media-list]");
    const mediaItems = qs(root, "[data-tps-product-media]");
    const thumbs = qs(root, "[data-tps-product-thumb]");
    const zoomLinks = qs(root, "[data-tps-product-zoom]");
    if (!mediaList || !mediaItems.length) return;
    root.dataset.tpsGalleryBound = "true";

    const setActive = (index, userInitiated) => {
      thumbs.forEach((thumb, thumbIndex) => {
        thumb.classList.toggle("is-active", thumbIndex === index);
      });
      if (!userInitiated) return;
      const activeThumb = thumbs[index];
      const strip = activeThumb?.parentElement;
      if (activeThumb && strip && strip.scrollWidth > strip.clientWidth + 4) {
        const target = activeThumb.offsetLeft - (strip.clientWidth - activeThumb.clientWidth) / 2;
        strip.scrollTo({ left: target, behavior: "smooth" });
      }
    };

    const ensureLightbox = () => {
      let lightbox = document.querySelector("[data-tps-product-lightbox]");
      if (lightbox) return lightbox;
      lightbox = document.createElement("div");
      lightbox.className = "tps-product-lightbox";
      lightbox.dataset.tpsProductLightbox = "true";
      lightbox.setAttribute("role", "dialog");
      lightbox.setAttribute("aria-modal", "true");
      lightbox.setAttribute("aria-label", "Ürün görseli");
      lightbox.innerHTML = `
        <button class="tps-product-lightbox__close" type="button" aria-label="Görseli kapat" data-tps-product-lightbox-close>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m6 6 12 12M18 6 6 18"/></svg>
        </button>
        <img class="tps-product-lightbox__image" alt="">
      `;
      document.body.appendChild(lightbox);
      lightbox.addEventListener("click", (event) => {
        if (event.target === lightbox || event.target.closest("[data-tps-product-lightbox-close]")) {
          closeLightbox();
        }
      });
      return lightbox;
    };

    const closeLightbox = () => {
      const lightbox = document.querySelector("[data-tps-product-lightbox]");
      if (!lightbox) return;
      lightbox.classList.remove("is-open");
      document.body.classList.remove("tps-product-lightbox-open");
    };

    const openLightbox = (url, alt) => {
      const lightbox = ensureLightbox();
      const image = lightbox.querySelector(".tps-product-lightbox__image");
      if (!image) return;
      image.src = url;
      image.alt = alt || "";
      lightbox.classList.add("is-open");
      document.body.classList.add("tps-product-lightbox-open");
      lightbox.querySelector("[data-tps-product-lightbox-close]")?.focus();
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener("click", (event) => {
        const target = mediaItems[index];
        if (!target) return;
        event.preventDefault();
        const isHorizontal = getComputedStyle(mediaList).display === "flex";
        target.scrollIntoView({ behavior: "smooth", block: isHorizontal ? "nearest" : "start", inline: "start" });
        setActive(index, true);
      });
    });

    zoomLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const image = link.closest("[data-tps-product-media]")?.querySelector("img");
        openLightbox(link.href, image?.alt || link.getAttribute("aria-label"));
      });
    });

    let lastActiveIndex = -1;
    const updateActive = () => {
      const isHorizontal = getComputedStyle(mediaList).display === "flex";
      let bestIndex = 0;
      let bestScore = -Infinity;
      mediaItems.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const visibleWidth = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
        const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
        const visibleArea = visibleWidth * visibleHeight;
        const distance = isHorizontal ? Math.abs(rect.left) : Math.abs(rect.top - 96);
        const score = visibleArea - distance;
        if (score > bestScore) {
          bestScore = score;
          bestIndex = index;
        }
      });
      setActive(bestIndex);
      if (bestIndex !== lastActiveIndex) {
        lastActiveIndex = bestIndex;
        const activeThumb = thumbs[bestIndex];
        const strip = activeThumb?.parentElement;
        if (activeThumb && strip) {
          if (strip.scrollWidth > strip.clientWidth + 4) {
            strip.scrollTo({ left: activeThumb.offsetLeft - (strip.clientWidth - activeThumb.clientWidth) / 2, behavior: "smooth" });
          } else if (strip.scrollHeight > strip.clientHeight + 4) {
            strip.scrollTo({ top: activeThumb.offsetTop - (strip.clientHeight - activeThumb.clientHeight) / 2, behavior: "smooth" });
          }
        }
      }
    };

    mediaList.addEventListener("scroll", updateActive, { passive: true });
    window.addEventListener("scroll", updateActive, { passive: true });
    window.addEventListener("resize", updateActive, { passive: true });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") closeLightbox();
    });
    updateActive();
  }

  var WISHLIST_KEY = "tps_wishlist";

  function getWishlist() {
    try {
      var raw = window.localStorage.getItem(WISHLIST_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function wishlistHas(handle) {
    return getWishlist().some(function (item) { return item.handle === handle; });
  }

  function reflectWishlistButtons(scope) {
    qs(scope || document, "[data-tps-wishlist-toggle]").forEach(function (btn) {
      var active = wishlistHas(btn.dataset.handle);
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-label", active ? "Favorilerden çıkar" : "Favorilere ekle");
      var label = btn.querySelector(".tps-wishlist-label");
      if (label) label.textContent = active ? "Favorilerde" : "Favorilere Ekle";
    });
  }

  function initWishlistButtons(scope) {
    qs(scope || document, "[data-tps-wishlist-toggle]").forEach(function (btn) {
      if (btn.dataset.tpsWishlistBound === "true") return;
      btn.dataset.tpsWishlistBound = "true";
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        var handle = btn.dataset.handle;
        if (!handle) return;
        var list = getWishlist();
        var index = list.findIndex(function (item) { return item.handle === handle; });
        if (index > -1) {
          list.splice(index, 1);
        } else {
          list.push({
            handle: handle,
            title: btn.dataset.title || "",
            url: btn.dataset.url || ("/products/" + handle),
            image: btn.dataset.image || "",
            price: btn.dataset.price || "",
          });
        }
        saveWishlist(list);
        reflectWishlistButtons(document);
        renderWishlistPage(document);
        updateWishlistCount();
      });
    });
    reflectWishlistButtons(scope || document);
  }

  function updateWishlistCount() {
    var count = getWishlist().length;
    qs(document, "[data-tps-wishlist-count]").forEach(function (el) {
      el.textContent = count;
      if (count < 1) { el.setAttribute("hidden", ""); } else { el.removeAttribute("hidden"); }
    });
  }

  function renderWishlistPage(scope) {
    var grid = (scope || document).querySelector("[data-tps-wishlist-grid]");
    if (!grid) return;
    var empty = document.querySelector("[data-tps-wishlist-empty]");
    var list = getWishlist();
    if (!list.length) {
      grid.innerHTML = "";
      if (empty) { empty.hidden = false; empty.style.display = ""; }
      return;
    }
    if (empty) { empty.hidden = true; empty.style.display = "none"; }
    grid.innerHTML = list.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '&width=600" alt="" loading="lazy">'
        : "";
      var t = (item.title || "").replace(/"/g, "&quot;");
      var p = (item.price || "").replace(/"/g, "&quot;");
      return '' +
        '<div class="tps-product-card">' +
          '<button class="tps-product-card__wishlist is-active" type="button" aria-label="Favorilerden çıkar" data-tps-wishlist-toggle data-handle="' + item.handle + '" data-title="' + t + '" data-url="' + item.url + '" data-image="' + item.image + '" data-price="' + p + '">' +
            '<svg class="tps-wishlist-heart" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.7 3.8 12.5a4.7 4.7 0 0 1 6.6-6.6l1.6 1.6 1.6-1.6a4.7 4.7 0 0 1 6.6 6.6z"/></svg>' +
          '</button>' +
          '<a class="tps-product-card__link" href="' + item.url + '">' +
            '<div class="tps-media">' + img + '</div>' +
          '</a>' +
          '<a class="tps-product-card__link" href="' + item.url + '">' +
            '<p class="tps-product-card__title">' + (item.title || "") + '</p>' +
            '<div class="tps-price"><strong>' + (item.price || "") + '</strong></div>' +
          '</a>' +
        '</div>';
    }).join("");
    initWishlistButtons(grid);
  }

  function boot(scope = document) {
    qs(scope, "[data-tps-hero]").forEach(initHero);
    qs(scope, "[data-tps-solutions-slider]").forEach(initSolutionsSlider);
    qs(scope, "[data-tps-carousel]").forEach(initCarousel);
    qs(scope, "[data-tps-accordion]").forEach(initAccordion);
    qs(scope, "[data-tps-header]").forEach(initHeader);
    qs(scope, "[data-tps-predictive-search]").forEach(initPredictiveSearch);
    qs(scope, ".tps-collection-section").forEach(initCollectionGrid);
    qs(scope, "[data-tps-product-gallery]").forEach(initProductGallery);
    initCartDrawer(scope);
    initProductCardForms(scope);
    initWishlistButtons(scope);
    renderWishlistPage(scope);
    updateWishlistCount();
    refreshCartCount();
  }

  document.addEventListener("DOMContentLoaded", () => boot());
  document.addEventListener("shopify:section:load", (event) => boot(event.target));
})();
